module.exports = __webpack_public_path__ + "img/other-considerations-header.aba26a7a.png";